export default __webpack_public_path__ + "static/media/apple-pay.eea952b6.png";